import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPCreditNoteActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Invoice/InvoiceBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceAPCreditNote"
				RenderedComponent={this.RenderedComponent}
				context="FinanceAPCreditNote"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPCreditNoteActivity)
